import React from 'react';

import { FastField, getIn } from 'formik';
import { FormControl } from '@mui/material';
import { isString } from 'lodash';
import { DateTimePicker } from '@mui/x-date-pickers';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export const DatePickerFormik = ({
                                     name,
                                     label,
                                     size,
                                     required,
                                     disabled,
                                     onChange,
                                     fullWidth = true,
                                     InputLabelProps,
                                     minDate,
                                     style
                                 }) => (
    <FastField
        name={ name }
        size={ size }
        shouldUpdate={ (nextProps, currentProps) => {
            if (getIn(nextProps.formik.values, name) !== getIn(currentProps.formik.values, name)) return true;
            if (getIn(nextProps.formik.errors, name) !== getIn(currentProps.formik.errors, name)) return true;
            if (getIn(nextProps.formik.touched, name) !== getIn(currentProps.formik.touched, name)) return true;
            if (nextProps.disabled !== currentProps.disabled) return true;
            if (nextProps.required !== currentProps.required) return true;
            if (nextProps.minDate !== currentProps.minDate) return true;

            return false;
        } }
    >
        { ({ form: { errors, setFieldValue }, field }) => (
            <FormControl fullWidth={ fullWidth } size={ size }>
                <DatePicker
                    { ...field }
                    value={ (isString(field?.value) && field?.value === '') ? null : field?.value }
                    label={ label }
                    disabled={ disabled }
                    displayWeekNumber
                    onChange={ (newDate) => {
                        setFieldValue(name, newDate);
                        onChange && onChange(newDate);
                    } }
                    minDate={ minDate }
                    slotProps={ {
                        textField: {
                            size: size,
                            required: required,
                            helperText: getIn(errors, field?.name),
                            error: !!getIn(errors, field?.name),
                            InputLabelProps: {
                                ...InputLabelProps
                            },
                            style: {
                                ...style
                            }
                        }
                    } }
                />
            </FormControl>
        ) }
    </FastField>
);

export const DateTimePickerFormik = ({
                                         name,
                                         label,
                                         size,
                                         required,
                                         disabled,
                                         onChange,
                                         fullWidth = true,
                                         InputLabelProps,
                                         minDate,
                                         maxDate,
                                         style
                                     }) => (
    <FastField
        name={ name }
        size={ size }
        shouldUpdate={ (nextProps, currentProps) => {
            if (getIn(nextProps.formik.values, name) !== getIn(currentProps.formik.values, name)) return true;
            if (getIn(nextProps.formik.errors, name) !== getIn(currentProps.formik.errors, name)) return true;
            if (getIn(nextProps.formik.touched, name) !== getIn(currentProps.formik.touched, name)) return true;
            if (nextProps.disabled !== currentProps.disabled) return true;
            if (nextProps.required !== currentProps.required) return true;
            if (nextProps.minDate !== currentProps.minDate) return true;
            if (nextProps.maxDate !== currentProps.maxDate) return true;

            return false;
        } }
    >
        { ({ form: { errors, setFieldValue }, field }) => (
            <FormControl fullWidth={ fullWidth } size={ size }>
                <DateTimePicker
                    { ...field }
                    value={ (isString(field?.value) && field?.value === '') ? null : field?.value }
                    label={ label }
                    disabled={ disabled }
                    displayWeekNumber
                    onChange={ (newDate) => {
                        setFieldValue(name, newDate);
                        onChange && onChange(newDate);
                    } }
                    minDate={ minDate }
                    maxDate={ maxDate }
                    slotProps={ {
                        textField: {
                            size: size,
                            required: required,
                            helperText: getIn(errors, field?.name),
                            error: !!getIn(errors, field?.name),
                            InputLabelProps: {
                                ...InputLabelProps
                            },
                            style: {
                                ...style
                            }
                        }
                    } }
                />
            </FormControl>
        ) }
    </FastField>
);

export default DatePickerFormik;